var _path, _path2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21354 9.63072C1.07282 9.45018 0.996048 9.22803 0.995276 8.99913C0.994503 8.77023 1.06977 8.54756 1.20927 8.36608C2.28768 6.95203 5.20329 3.66397 8.99934 3.66397C12.7452 3.66397 15.6886 6.9499 16.7819 8.36501C16.9233 8.54651 17 8.76997 17 9C17 9.23003 16.9233 9.45349 16.7819 9.63499C15.6886 11.0501 12.7452 14.336 8.99934 14.336C5.25345 14.336 2.30422 11.0426 1.21354 9.63072Z",
    stroke: "#13100D",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99932 12.2016C10.7675 12.2016 12.2009 10.7682 12.2009 9C12.2009 7.2318 10.7675 5.79838 8.99932 5.79838C7.23111 5.79838 5.7977 7.2318 5.7977 9C5.7977 10.7682 7.23111 12.2016 8.99932 12.2016Z",
    stroke: "#13100D",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.3536,
    y1: 1.35355,
    x2: 1.35355,
    y2: 16.3536,
    stroke: "#13100D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.ce12c66974b7ef5454d6b905ee2263d1.svg";
export { ForwardRef as ReactComponent };